<template>
  <div class="juou-card">
    <HpsfirProTable
      ref="tableRef"
      export-file-name="客户数据"
      title="客户数据"
      :paginations="{ pageSize: 10 }"
      :columns="columns"
      :get-data="getData"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
  </div>
</template>
<script lang="ts" setup>
import {
  useBaseAsync,
  useBaseOperateStore,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { computed, ref } from 'vue';
import dayjs from 'dayjs';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();
const baseOperateStore = useBaseOperateStore();

const addInitValue = {

};
const CUSTOMER_TYPE_VAL = '__CUSTOMER__';

const customerTypeOptions = [
  { label: '客户', value: CUSTOMER_TYPE_VAL },
  { label: '白名单', value: '白名单' },
  { label: '黑名单', value: '黑名单' },
];

const openStatusOptions = [
  { label: '开门成功', value: true },
  { label: '开门失败', value: false },
];

const conditionsInitValue = {
  timeRange: [
    dayjs().subtract(6, 'day')
      .format('YYYY-MM-DD'),
    dayjs().format('YYYY-MM-DD'),
  ],
};
const currentRow = ref<any>();
// 可管理服务商，则是管理员
const canAdminFacilitator = computed(() => baseOperateStore.operates?.find((item) => item.key === 'ADMIN_STORE_FACILITATOR'));

// eslint-disable-next-line max-lines-per-function
const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'timeRange',
      label: '时间范围',
      type: 'datepick',
      isCondition: true,
      hideCreate: true,
      hideEdit: true,
      hideTable: true,
      pickType: 'daterange',
      fastPick: [
        {
          name: '近7日',
          handler: (formdata) => {
            formdata['timeRange'] = [
              dayjs().subtract(6, 'day')
                .format('YYYY-MM-DD'),
              dayjs().format('YYYY-MM-DD'),
            ];
          },
          dateChangeHandler: ([start, end]) => dayjs().format('YYYY-MM-DD') === end && dayjs(end).subtract(6, 'day')
            .format('YYYY-MM-DD') === start,
        },
        {
          name: '近30日',
          handler: (formdata) => {
            formdata['timeRange'] = [
              dayjs().subtract(29, 'day')
                .format('YYYY-MM-DD'),
              dayjs().format('YYYY-MM-DD'),
            ];
          },
          dateChangeHandler: ([start, end]) => dayjs().format('YYYY-MM-DD') === end && dayjs(end).subtract(29, 'day')
            .format('YYYY-MM-DD') === start,
        },
      ],
    },
    ...(
      canAdminFacilitator.value ? [
        {
          name: 'deviceRemark',
          label: '设备备注',
          type: 'string',
          isCondition: true,
          hideEdit: true,
          hideCreate: true,
          order: 10,
        },
      ] : []
    ) as any,
    {
      name: 'storeName',
      label: '店铺名称',
      type: 'string',
      isCondition: true,
    },
    {
      name: 'phone',
      label: '客户手机号',
      type: 'string',
      isCondition: true,
    },

    {
      name: 'customType',
      label: '类型',
      type: 'select',
      isCondition: true,
      options: customerTypeOptions,
      render: (scope: any) => scope?.row?.customType || '客户',
    },

    {
      name: 'date',
      label: '开门年月日',
      type: 'string',
      render: (scope: any) => (scope?.row?.createTime ? dayjs(scope.row.createTime).format('YYYY年MM月DD日') : ''),
    },

    {
      name: 'time',
      label: '开门时间',
      type: 'string',
      render: (scope: any) => (scope?.row?.createTime ? dayjs(scope.row.createTime).format('HH:mm:ss') : ''),
    },

    /*  {
      name: 'userGeo',
      label: '定位',
      width: 120,
      type: 'string',
      render: (scope: any) => {
        const userGeo = scope?.row?.userGeo;
        return userGeo ? `${userGeo.longtitude}, ${userGeo.latitude}` : '';
      },
    }, */
    {
      name: 'status',
      label: '开门状态',
      type: 'select',
      isCondition: true,
      hideTable: true,
      hideCreate: true,
      hideEdit: true,
      options: openStatusOptions,
    },
    {
      name: 'msg',
      label: '开门状态',
      type: 'string',
    },
    {
      name: 'companyName',
      label: '快递公司',
      type: 'string',
    },
    {
      name: 'trackingNumber',
      label: '快递单号',
      type: 'string',
    },

    /* {
      name: 'distance',
      label: '开门距离',
      type: 'string',
      render: (scope: any) => (scope?.row?.distance ? `${scope.row.distance}米` : '0米'),
    }, */
  ]);
});


const operates: any[] = [];
const loading = ref(false);


// eslint-disable-next-line max-lines-per-function
const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const endTime = dayjs(filter.conditions.timeRange[1]).isSame(dayjs(), 'day')
      ? dayjs().format('HH:mm:ss')
      : '23:59:59';
    const recordParams = {
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '' || key === 'timeRange') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),
      start: `${filter.conditions.timeRange[0]} 00:00:00`,
      end: `${filter.conditions.timeRange[1]} ${endTime}`,

    };
    const res = await useApi().recordApi.pageAdminRecordrecord({
      ...recordParams,
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },

    });
    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.idHex})操作，请谨慎操作`;


init();

</script>
<style lang="scss" scoped>
</style>
